const mixin = {
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManagement() {
      return this.$store.getters.isManagement;
    }
  }
}
export default mixin;
